import moment from 'moment';
import { Box, styled } from '@material-ui/core';
import { useAppContext } from 'Providers/AppProvider/AppContext';

const NewBadge = styled(Box)({
  width: 'fit-content',
  color: 'white',
  fontWeight: 600,
  borderRadius: 16,
  padding: '4px 8px',
  boxShadow: '0px 2px 4px 0px #30363C29',
  background: '#1E96FC',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});

const ResourceNewBadge = ({
  MaterilaLastChangeDate
}: {
  MaterilaLastChangeDate: Date | string;
}) => {
  const { user } = useAppContext();

  return (
    moment.utc(MaterilaLastChangeDate).diff(user.LastActiveDate, 'hours') >
      -24 && <NewBadge>New</NewBadge>
  );
};

export default ResourceNewBadge;
